import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTextItemTablePanelHandlerComponent } from './fi-text-item-table-panel-handler.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';

@NgModule({
    declarations: [FiTextItemTablePanelHandlerComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, FiAppTextSharedModule, InfoIconModule],
    exports: [FiTextItemTablePanelHandlerComponent],
})
export class FiTextItemTablePanelHandlerModule {}
